export interface BackupSettings {
    id: string;
    frequency: string;
    time?: string;
    dayOfWeek?: string;
    dayOfMonth?: string;
    monthOfYear?: string;
    enabled?: boolean;
    userId: string;
    created?: string;
    updated?: string;
}

export class CreateUpdateBackupSettingsRequest implements Omit<BackupSettings, 'id' | 'created' | 'updated' | 'userId'> {
    frequency!: string;
    time?: string;
    dayOfWeek?: string;
    dayOfMonth?: string;
    monthOfYear?: string;
    enabled?: boolean;

    constructor(data: CreateUpdateBackupSettingsRequest) {
        Object.assign(this, data);
    }
}

export class BackupSettingsResponse {
    public settings: BackupSettings;

    constructor(settings: BackupSettings) {
        this.settings = settings;
    }
}
